<div class="hidden md:flex flex-col project-filter-container" *ngIf="groupedCommittees().length > 0">
  <div class="flex flex-col gap-4 flex-wrap px-2 w-full">
    <span class="font-sans text-lg font-bold pl-1">Committee</span>
    <div class="flex flex-col gap-2">
      <p-select
        [options]="groupedCommittees()"
        placeholder="Select a committee"
        [ngModel]="selectedCommittee()"
        [group]="true"
        appendTo="body"
        class="w-full px-1"
        (onChange)="onCommitteeChange($event)"
        [showClear]="selectedCommittee().ID"
        (onClear)="onCommitteeClear()">
        <ng-template let-group pTemplate="group">
          <div class="flex align-items-center">
            <span class="text-xs">{{ group.label }}</span>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="option">
          <div class="flex align-items-center">
            <span class="text-xs pl-2">{{ option.label }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="selectedItem">
          <div class="flex gap-1 align-items-center">
            <span class="text-xs">{{ selectedCommittee().Name }}</span>
            <span class="text-xs text-gray-400">({{ selectedCommittee().ProjectName }})</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>
</div>
